import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWrite3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWrite3"><Path d="M20.1289 13.3691L17.4775 20H20V22H4V20H6.52246L3.87109 13.3691L11 3.18359V11.709C10.1172 12.0948 9.5 12.975 9.5 14C9.5 15.3807 10.6193 16.5 12 16.5C13.3807 16.5 14.5 15.3807 14.5 14C14.5 12.975 13.8828 12.0948 13 11.709V3.18359L20.1289 13.3691Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWrite3;
